import React, { useState } from "react";
import { Table, Button, Input, Space, } from 'antd';
import strings from '../../utils/strings';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function ReportTable() {
    const reports = useReportsStore()
    const data = reports.agentsBalance.data;
    const loading = reports.agentsBalance.loading;

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');

    let searchInput;
    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}>
                        جستجو
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>ریست</Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (text),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const columns = [
        {
            title: "نام کاربری",
            dataIndex: "Username",
            key: "Username",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.Username ? first = a.Username : first = '';
                b.Username ? second = b.Username : second = '';
                return first.length - second.length
            },
            ellipsis: true,
            ...getColumnSearchProps('Username', 'نام کاربری'),
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "نام و نام خانوادگی",
            dataIndex: "FullName",
            key: "FullName",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.FullName ? first = a.FullName : first = '';
                b.FullName ? second = b.FullName : second = '';
                return first.length - second.length
            },
            ...getColumnSearchProps('FullName', 'نام و نام خانوادگی'),
        },
        {
            title: "جمع پرداختی",
            dataIndex: "SumPaid",
            key: "SumPaid",
            ...getColumnSearchProps('SumPaid', 'جمع پرداختی'),
            sorter: (a, b) => a.SumPaid.toString().length - b.SumPaid.toString().length,
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "جمع کارمزد",
            dataIndex: "SumCommission",
            key: "SumCommission",
            ...getColumnSearchProps('SumCommission', 'جمع کارمزد'),
            sorter: (a, b) => a.SumCommission.toString().length - b.SumCommission.toString().length,
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "مانده",
            dataIndex: "RemainAmount",
            key: "RemainAmount",
            ...getColumnSearchProps('RemainAmount', 'مانده'),
            sorter: (a, b) => a.RemainAmount.toString().length - b.RemainAmount.toString().length,
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "استان",
            dataIndex: "ProvinceName",
            key: "ProvinceName",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.ProvinceName ? first = a.ProvinceName : first = '';
                b.ProvinceName ? second = b.ProvinceName : second = '';
                return first.length - second.length
            },
            ...getColumnSearchProps('ProvinceName', 'استان'),
        },
        {
            title: "شهر",
            dataIndex: "CityName",
            key: "CityName",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.CityName ? first = a.CityName : first = '';
                b.CityName ? second = b.CityName : second = '';
                return first.length - second.length
            },
            ...getColumnSearchProps('CityName', 'شهر'),
        }
    ];

    return (
        <Table
            style={{ overflowX: 'scroll' }}
            className="custom-table"
            size="medium"
            bordered
            columns={columns}
            loading={loading}
            rowKey="Username"
            dataSource={data}
            scroll={true}
        />
    );
}